// order-status.service.ts

import httpRequest from "@/auth/http-client";
import {
  IOrderCancelled,
  IOrderConfirmed,
  IOrderDelivered,
  IOrderError,
  IOrderHandling,
  IOrderInvoiced,
  IOrderPaid,
  IOrderShipped,
} from "@/interfaces/order-status.interfaces";

class OrderStatusService {
  private baseUrl = "api/v1/order";

  async confirm(orderData: IOrderConfirmed): Promise<void> {
    await httpRequest.post(`${this.baseUrl}/confirmed`, orderData);
  }

  async pay(orderData: IOrderPaid): Promise<void> {
    await httpRequest.post(`${this.baseUrl}/paid`, orderData);
  }

  async handling(orderData: IOrderHandling): Promise<void> {
    await httpRequest.post(`${this.baseUrl}/handling`, orderData);
  }

  async invoice(orderData: IOrderInvoiced): Promise<void> {
    await httpRequest.post(`${this.baseUrl}/invoiced`, orderData);
  }

  async ship(orderData: IOrderShipped): Promise<void> {
    await httpRequest.post(`${this.baseUrl}/shipped`, orderData);
  }

  async deliver(orderData: IOrderDelivered): Promise<void> {
    await httpRequest.post(`${this.baseUrl}/delivered`, orderData);
  }

  async cancel(orderData: IOrderCancelled): Promise<void> {
    await httpRequest.post(`${this.baseUrl}/cancelled`, orderData);
  }

  async reportError(orderData: IOrderError): Promise<void> {
    await httpRequest.post(`${this.baseUrl}/error`, orderData);
  }
}

const orderStatusService = new OrderStatusService();
export default orderStatusService;
